import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "q-pa-lg column bg-grey-11" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h5", null, "Add new access", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_agreement_form_field_new_member = _resolveComponent("agreement-form-field-new-member")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_form = _resolveComponent("q-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_q_form, {
      greedy: "",
      onSubmit: _withModifiers(_ctx.onSubmit, ["prevent"]),
      ref: "form"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_agreement_form_field_new_member, {
          agreementId: _ctx.agreementId,
          modelValue: _ctx.newMemberModel,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newMemberModel) = $event))
        }, null, 8, ["agreementId", "modelValue"]),
        (_ctx.newMemberModel !== '')
          ? (_openBlock(), _createBlock(_component_q_btn, {
              key: 0,
              label: "Add member",
              color: "primary",
              type: "submit",
              unelevated: "",
              "no-caps": "",
              class: "q-mt-md"
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["onSubmit"])
  ]))
}